import { get, isNil } from 'lodash-es';
import { getCarZingCta } from 'site-modules/shared/components/inventory/utils/carzing';
import { CTA_TYPE } from 'site-modules/shared/constants/inventory/lead-form';
import { FLAVORS } from 'site-modules/shared/constants/flavors';
import { getSessionInventoryFilters } from 'site-modules/shared/utils/inventory/session-inventory-filters';
import { flavorStore } from 'client/utils/flavor';
import { getQuery } from 'client/utils/location';

export const DEFAULT_PROXIMITY_REACH = 50;
export const LEAD_FORM_CTAS = [CTA_TYPE.NEW.BASE, CTA_TYPE.USED.BASE];

const getFiniteNumber = value => {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export const isProximityLeadFormExperience = ({ vinData, location }) => {
  if (!flavorStore.has(FLAVORS.PROXIMITY)) return false;

  const query = getQuery(location);
  const sessionReach = getSessionInventoryFilters().reach;
  const reach = getFiniteNumber(query.reach) ?? getFiniteNumber(sessionReach) ?? DEFAULT_PROXIMITY_REACH;
  const distanceValue = get(vinData, 'dealerInfo.distance');
  if (isNil(distanceValue)) return false;

  const distance = getFiniteNumber(distanceValue);
  return distance !== null && distance > reach;
};

export const getVdpCtasWithoutLeadForm = ctas => ctas.filter(cta => !LEAD_FORM_CTAS.includes(cta));

export function getVdpCtas({ vinData, isSimulatedLeadForm = false, location }) {
  const carZingCta = getCarZingCta(vinData);
  let ctas = carZingCta ? [carZingCta] : get(vinData, 'computedDisplayInfo.ctas', []);
  if (isSimulatedLeadForm) {
    ctas = [CTA_TYPE.USED.BASE];
  }

  return isProximityLeadFormExperience({ vinData, location }) ? getVdpCtasWithoutLeadForm(ctas) : ctas;
}
